import React, { Component } from 'react';
// utils
import {Translations} from '../../../../utils';

export default class Status extends Component{
  constructor(props) {
    super(props);
    this.state = {
          title : this.translations(this.props.data.text3),
          display : 'none',
          arrowIsOpen : false
       }
    this._registerCloseEvent();
  }

  _registerCloseEvent = () => {
    document.body.onclick = function(e) {
      if(this.state.display === 'block'){
        this._openHander(e);
      }
    }.bind(this);
    this._getStatusOnchange = this._getStatusOnchange.bind(this);
  }

  handleWindowClick = () => {
      this.setState({
        display: 'none',
        arrowIsOpen: false
      });
  }

  componentWillUnmount(){
    window.removeEventListener('click', this.handleWindowClick);
  }

  // componentDidMount(){
  //   window.addEventListener('click', this.handleWindowClick)
  // }

  _openHander = (e) => {
    //  e.stopPropagation();
       if(this.state.arrowIsOpen === true && this.state.display === 'block'){
         this.setState({
           arrowIsOpen: false,
           display: 'none'
         })
       }else{
         this.setState({
           arrowIsOpen: true,
           display: 'block'
         })
       }
  }

  _getStatusOnchange (event){
  //event.stopPropagation();
   if(event.target.getAttribute("data-name")){
     this.setState({
       title : event.target.getAttribute("data-name")
     })
     this.props.getStatusOnchange(event.target.getAttribute("data-name"));
   }
  }

  _clearStatus = () => {
    this.setState({
      title: this.translations(this.props.data.text3)
    })
  }

  translations = (word) => {
    return Translations(word, this.props.lang.currentLang.lang, this.props.lang.translatedData)
  }

  render(){
    const display = {
        display : this.state.display
    }
    return(
      <div className="gdoc-caselist-filter-dropcontainer">
        <div
          className="gdoc-addproduct-pdiv-lan status"
          onClick={this._openHander}
          value={this.props.value}
          tabIndex="0"
          role="list"
          data-dropdown="gdoc-addproduct-select-lng"
          aria-controls="gdoc-addproduct-select-lng"
          aria-expanded="false"
        >
          <span className="gdoc-addproduct-selected-country">
            <span className="gdoc-addproduct-plussign">{this.translations(this.props.data.text2)}</span>
             <span className="gdoc-addproduct-title">{this.state.title}</span>
          </span>
          <span className ="gdoc-addproduct-bar"> </span>
          <i className={this.state.arrowIsOpen === true ? 'icon icon-chevron-up  gdoc-addproduct-icondown' : 'icon icon-chevron-down gdoc-addproduct-icondown' }></i>
        </div>
        <ul
          id="gdoc-addproduct-select-lng"
          className="gdoc-addproduct-custom-dropdown gdocs-set-dropdown-ht"
          style={display}
        >
        {
          this.props.eventStatus.length > 0
          ? Object.keys(this.props.eventStatus).map((key)=>  <li
              key={key}
              onClick={(event) => this._getStatusOnchange(event)}
              data-value={this.props.eventStatus[key].name}
              data-name={this.props.eventStatus[key].value}
            >
              {this.props.eventStatus[key].value}
            </li> )
          : ''
        }
        </ul>
     </div>
    )
  }
}

Status.defaultProps = {
eventStatus : []
}



// WEBPACK FOOTER //
// ./src/components/CaseBody/CaseHistory/Grid/Status.js